import React from 'react';
import FormGroup from "../../components/formGroup";
import MySelect from "../../components/form/mySelect";
import {isObject} from "lodash";

function ChoixLangue(props) {
    const langue = isObject(props.selected)
        ? props.selected
        : (props.selected === null
            ? props.parameters.CoursLangue3ID.find(f => f.label === "Allemand")
            : props.parameters.CoursLangue3ID.find(f => f.value === props.selected));

    return (
        <div>
            <FormGroup label={"Troisième langue"}
                       name={"CoursLangue3ID"}
                       type={MySelect}
                       value={langue}
                       options={props.parameters.CoursLangue3ID}
                       onChange={props.onChange.bind(this)}
                       required={true}/>
        </div>
    );
}

export default ChoixLangue;